var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSelectedThumbsUp = function SvgSelectedThumbsUp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4531 5.63344C16.2947 5.45395 16.1 5.31021 15.8818 5.21177C15.6635 5.11334 15.4269 5.06245 15.1875 5.0625H11.25V3.9375C11.25 3.19158 10.9537 2.47621 10.4262 1.94876C9.89879 1.42132 9.18342 1.125 8.4375 1.125C8.333 1.12493 8.23054 1.15396 8.14162 1.20886C8.0527 1.26375 7.98083 1.34233 7.93406 1.43578L5.27766 6.75H2.25C1.95163 6.75 1.66548 6.86853 1.4545 7.0795C1.24353 7.29048 1.125 7.57663 1.125 7.875V14.0625C1.125 14.3609 1.24353 14.647 1.4545 14.858C1.66548 15.069 1.95163 15.1875 2.25 15.1875H14.3438C14.7549 15.1876 15.1519 15.0377 15.4603 14.7658C15.7687 14.4939 15.9672 14.1188 16.0186 13.7109L16.8623 6.96094C16.8923 6.7233 16.8712 6.48201 16.8007 6.25313C16.7301 6.02424 16.6116 5.813 16.4531 5.63344ZM2.25 7.875H5.0625V14.0625H2.25V7.875Z",
    fill: "#4652B7"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSelectedThumbsUp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SelectedThumbsUp.5ff27a56.svg";
export { ForwardRef as ReactComponent };